export const SET_MARKETING_DATA = 'SET_MARKETING_DATA';
export const SET_OPT_STATUS = 'SET_OPT_STATUS';
export const SET_OPT_OUT_CUSTOMER_FOR_SMS_MARKETING =
  'SET_OPT_OUT_CUSTOMER_FOR_SMS_MARKETING';
export const SET_OPT_IN_URL = 'SET_OPT_IN_URL';
export const CLEAN_OPT_IN_URL = 'CLEAN_OPT_IN_URL';
export const CHANGE_OPT_STATUS = 'CHANGE_OPT_STATUS';
export const SET_DEFAULT_PROMOTION = 'SET_DEFAULT_PROMOTION';



// WEBPACK FOOTER //
// ./src/store/reducers/marketing/actionTypes.js